<script setup>
import ListUsers from '@/Components/Models/User/List.vue';
import { UserAddIcon } from "@heroicons/vue/outline"
import moment from 'moment';

const props = defineProps({
	users: {
		type: Array,
		default: () => ([]),
	},
	relationship: {
		type: String,
		required: true,
	},
	related: {
		type: Object,
		required: true,
	},
})

const emit = defineEmits([
	'create:users',
	'view:users'
])

const create = () => {
	emit('create:users')
}

const clicked = (user) => {
	emit('clicked', user)
}

const dateFormatted = (date) => moment(date).format("DD MMM YYYY")

const getRelationshipRole = (params) => {
	// if user is admin
	if( params.data.role === "admin" ){
		return "Admin"
	}
	let roleName = params.data.permissions[props.relationship].find(model => model.id == props.related.id).role.name
	roleName = roleName.split(props.relationship + ':').pop()
	// capitalize
	return roleName.charAt(0).toUpperCase() + roleName.slice(1)
}

</script>

<template>
	<SectionCard title="Contacts" :full-width="true" data-testid="related-users-card">
		<div class="my-3">
			<ListUsers 
				:items="users"
				:pagination="false" 
				@item-clicked="clicked"
				:column-defs="[
					{
						field: 'name',
						flex: 4,
					},
					{ 
						field: 'email', 
						flex: 6
					},
					{
						field: 'created_at',
						headerName: 'Created',
						flex: 4,
						valueFormatter: (params) => dateFormatted(params.value)
					},
					{
						headerName: 'Role',
						valueGetter: getRelationshipRole, 
						flex: 2
					},
				]"
			/>
		</div>

		<template #footer>
			<Button 
				@click="create" 
				class="block" 
				color="blue"
				data-testid="add-user-btn"
			>
				<UserAddIcon class="w-4 h-4 mr-2 inline" /> Add contact
			</Button>
		</template>
	</SectionCard>
</template>